import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';

import * as colors from '../utils/colors';

const HeaderWrapper = styled.header`
  background-color: ${colors.ebbRed};
`;

const HeaderInner = styled.div`
  margin: auto;
  position: relative;
  padding: 15px 0 10px 0;
  margin: 0 0 10px 0;
`;

const Title = styled.h1`
  color: ${colors.white};
  text-align: center;
`;

const Header = ({ siteTitle }) => (
  <HeaderWrapper>
    <HeaderInner>
      <Title>{'Eisbären Berlin Liveticker'.toUpperCase()}</Title>
    </HeaderInner>
  </HeaderWrapper>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js